import * as client from "_graphql-types";
import * as types from "./types";
import { format } from "date-fns";

type Sdk = ReturnType<typeof client.getSdk>;

type PerformanceBackfillArgs = {
  id: "performanceBackfill";
  data: {
    investmentIds: number[];
    startDate: Date;
    endDate: Date;
  };
};

async function update(sdk: Sdk, params: PerformanceBackfillArgs) {
  switch (params.id) {
    case "performanceBackfill":
      const { investmentIds } = params.data;
      const startDate = format(params.data.startDate, "yyyy-MM-dd");
      const endDate = format(params.data.endDate, "yyyy-MM-dd");
      const { bloombergDiligenceExtract } = await sdk.bloombergDiligenceExtract(
        {
          investmentIds,
          startDate,
          endDate,
        }
      );
      console.log("bloombergDiligenceExtract ->", bloombergDiligenceExtract);

      const datasetIds = bloombergDiligenceExtract.flatMap(x => [
        x.monthlyId,
        x.dailyId,
      ]);
      console.log("datasetIds ->", datasetIds);

      for (let timeout = Date.now() + 300_000; ; ) {
        const { bloombergDiligenceExtractStatus } =
          await sdk.bloombergDiligenceExtractStatus({ datasetIds });
        console.log(
          "bloombergDiligenceExtractStatus ->",
          bloombergDiligenceExtractStatus
        );

        const done = bloombergDiligenceExtractStatus.every(
          x => x.statusCode === 200
        );
        if (done) break;

        await new Promise(resolve => setTimeout(resolve, 10_000));
        if (Date.now() > timeout) {
          throw new Error("Timeout fetching Bloomberg data");
        }
      }

      const inputs = bloombergDiligenceExtract.map(x => ({
        currency: x.currency,
        monthlyId: x.monthlyId,
        dailyId: x.dailyId,
      }));
      console.log("inputs ->", inputs);

      const { bloombergDiligenceLoad } = await sdk.bloombergDiligenceLoad({
        inputs,
      });
      console.log("bloombergDiligenceLoad ->", bloombergDiligenceLoad);

      return { data: { id: "performanceBackfill" } };
  }
}

export const performanceBackfill = types.dataProvider({
  update,
});
